
    <span class="inline-svg" [innerHTML]="inlineSvg"></span>
  